import { NavigationGuard } from 'vue-router';

import { OrderStep } from '@/constants/order/constants';
import { globalMutations, globalState } from '@/store/modules/global';

export const savePrevious: NavigationGuard = (to, from, next) => {
	globalMutations.setPreviousRoute(from);
	next();
};

/**
 * Nazwa kroku, Z KTÓREGO protetyk przyszedł — albo `undefined`, gdy przyszedł spoza kreatora.
 *
 * DLACZEGO OSOBNA FUNKCJA, a nie odczyt w komponencie: `globalState.previousRoute` to **funkcja**
 * (vuex-typed mapuje stan na `() => wartość`), więc `globalState.previousRoute?.name` czyta nazwę
 * FUNKCJI, czyli pusty napis — i robi to cicho, bo `string as OrderStep` jest legalną asercją,
 * którą przepuszcza i TypeScript, i build. Dokładnie ten błąd zamienił całą rundę naprawy kierunku
 * nawigacji w zmianę zerową: zielona bramka, zachowanie bez zmian (znalazła Rita, GLA-89 r4).
 *
 * Tu brak nawiasów wywraca test, a nie demo.
 */
export function previousStepName(): OrderStep | undefined {
	const route = globalState.previousRoute();
	const name = route?.name;

	return typeof name === 'string' && name ? (name as OrderStep) : undefined;
}
